import r from"styled-components";import{theme as o}from"../../../../../theme.js";const i=r.div`
  background-color: ${o.colors.gray[50]};
  font-size: 14px;
  line-height: 21px;
  color: ${o.colors.gray[700]};
  padding: ${o.spacing*4}px;
  border-radius: ${o.radius}px;
`;export{i as Container};
